module.exports = __webpack_public_path__ + "img/fingerplacement.3be32f61.png";